import React, { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon_Close from '../../Assets/Icons/Icon_Close.png';
import Icon_Color_Logout from '../../Assets/Icons/Icon_Color_Logout.png';
import { Context_UI } from '../../Contexts/Context_UI';
import { useScheduleManagement } from '../../Contexts/Context_ScheduleManagement';
import { useMapRenderer } from '../../Contexts/Context_MapRenderer';
import UI_Card from '../ERUMAUI/UI_Card';
import UI_ChipGroup from '../ERUMAUI/UI_ChipGroup';
import { useAccounts } from '../../Contexts/Context_Accounts';
import UI_Dropdown from '../ERUMAUI/UI_Dropdown';
import { useTemplating } from '../../Contexts/Context_Templating';
import { useStatus } from '../../Contexts/Context_Status_Global';
import UI_Divider from '../ERUMAUI/UI_Divider';
import UI_Form from '../ERUMAUI/UI_Form';
import UI_Input_Text from '../ERUMAUI/UI_Input_Text';
import UI_Input_Text_Long from '../ERUMAUI/UI_Input_Text_Long';
import UI_Icon from '../ERUMAUI/UI_Icons';
import UI_Button from '../ERUMAUI/UI_Button';
import UI_UpdatingStatus from '../ERUMAUI/UI_UpdatingStatus';
import UI_Horizontal_Tabs from '../ERUMAUI/UI_Horizontal_Tabs';

export default function Subwindow_Modal_User_Logout({ id, zIndex, isActive }) {
    const UI = useContext(Context_UI);
    const { Account_Fetch_ByID_Basic } = useAccounts();
    const [Account, Account_Set] = useState({ Name: "", Email: "" });
    const { Template_List } = useTemplating();
    const { Confirmer_Respond, Unsaved_Add, Unsaved_Clear } = useStatus();
    const Navigate = useNavigate();
    const Close = (Type) => {
        setTimeout(function () {
            UI.Subwindows_Close(id);
        }, 500);
    }

    const Confirm = async () => {
        Confirmer_Respond(true, {}, true, "Window_User_Logout");


    }

    const Cancel = async () => {
        // if (await Unsaved_Clear("Edit schedule")) {
        Navigate("/user");
        Confirmer_Respond(false, {}, true, "Window_User_Logout");
        // }
    }


    return (
        <ui-subwindow Type='Modal' id={id} State='Active' Visibility='Open' {...(!isActive ? { inert: "" } : {})} >
            <ui-subwindow-titlebar>
                <h2 className='Subwindow_TitleBar_Title'>

                </h2>
                <button className='Subwindow_TitleBar_Control' onClick={Cancel}             >
                    <img className='Subwindow_TitleBar_Control_Icon' src={Icon_Close} draggable='false' loading='lazy' alt='' />
                </button>
            </ui-subwindow-titlebar>
            <ui-subwindow-content>
                <div className='Subwindow_Content_Icon'>
                    <img src={Icon_Color_Logout} className='Subwindow_Content_Icon_Image' draggable={false} loading='lazy' />
                </div>
                <h2 className='Subwindow_TitleBar_Title' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Password changed successfully!
                </h2>

                <p className='General_Paragraph' style={{ textAlign: "center", marginBottom: "10px" }}>
                    Please sign in again with your new password.
                </p>
            </ui-subwindow-content>
            <ui-subwindow-controls>
                {/* <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Cancel}>
                    Cancel
                </button> */}
                <button className='General_Button Subwindow_Control' Type='Secondary' onClick={Confirm}>
                    Logout
                </button>

            </ui-subwindow-controls>
        </ui-subwindow>
    );
}
